import { useViewerStore } from '../store/store';

/**
 * Unblocks the dashboard gate, opens the dashboard, and shows a banner with the load failure message.
 * Used instead of a blocking modal so users can still use dashboard actions where appropriate.
 */
export function reportSiteLoadErrorForDashboard(message: string): void {
    const viewportOnly = useViewerStore.getState().isViewportOnlyEmbed;
    useViewerStore.setState({
        loadingCompleted: true,
        refreshingShade: false,
        siteLoadingError: message,
        // Keep canvas visible in viewport-only embeds (no dashboard chrome).
        isDashboardOpen: viewportOnly ? false : true,
    });
    if (!viewportOnly || typeof window === 'undefined' || window.parent === window) return;
    const text = message.trim();
    if (!text) return;
    try {
        // Must match PCI_ONEDRAW_LOAD_ERROR_MSG in preContractEmbedBridge.ts
        window.parent.postMessage(
            { type: 'pci-onedraw-load-error', message: text },
            window.location.origin,
        );
    } catch {
        /* ignore */
    }
}
